import { getPlatformLogoPath, getPlatformDisplayName } from "src/app/common/platformUtils";
import { Platform } from "../api";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { ISelectOption } from "./selectOption.interface";

export const PlatformSelectOptions: ISelectOption[] = [
    {
        id: Platform.powerplatform,
        value: Platform.powerplatform,
        displayName: getPlatformDisplayName(Platform.powerplatform),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.powerplatform),
    },
    {
        id: Platform.workato,
        value: Platform.workato,
        displayName: getPlatformDisplayName(Platform.workato),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.workato),
    },
    {
        id: Platform.powerBI,
        value: Platform.powerBI,
        displayName: getPlatformDisplayName(Platform.powerBI),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.powerBI),
    },
    {
        id: Platform.salesforce,
        value: Platform.salesforce,
        displayName: getPlatformDisplayName(Platform.salesforce),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.salesforce),
    },
    {
        id: Platform.serviceNow,
        value: Platform.serviceNow,
        displayName: getPlatformDisplayName(Platform.serviceNow),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.serviceNow),
    },
    {
        id: Platform.chatGptEnterprise,
        value: Platform.chatGptEnterprise,
        displayName: getPlatformDisplayName(Platform.chatGptEnterprise),
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        iconPath: getPlatformLogoPath(Platform.chatGptEnterprise),
    },
    {
        id: "Airtable",
        value: "Airtable",
        displayName: "Airtable ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "Appian",
        value: "Appian",
        displayName: "Appian ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "Automation Anywhere",
        value: "Automation Anywhere",
        displayName: "Automation Anywhere ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "BluePrism",
        value: "BluePrism",
        displayName: "BluePrism ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "Bubble",
        value: "Bubble",
        displayName: "Bubble ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "Dell Boomi",
        value: "Dell Boomi",
        displayName: "Dell Boomi ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "IFTTT",
        value: "IFTTT",
        displayName: "IFTTT ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "JitterBit",
        value: "JitterBit",
        displayName: "JitterBit ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "Mendix",
        value: "Mendix",
        displayName: "Mendix ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "MuleSoft",
        value: "MuleSoft",
        displayName: "MuleSoft ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "OutSystems",
        value: "OutSystems",
        displayName: "OutSystems ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "SnapLogic",
        value: "SnapLogic",
        displayName: "SnapLogic ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
    {
        id: "UiPath",
        value: "UiPath",
        displayName: "UiPath ( alpha version )",
        filterType: FilterTypesEnum.Platform,
        categoryName: FilterTypesEnum.Platform.toString(),
        disabled: true,
    },
];
